
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/acesse-seu-relatorio",
      function () {
        return require("private-next-pages/acesse-seu-relatorio.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/acesse-seu-relatorio"])
      });
    }
  